module.exports = __webpack_public_path__ + "static/media/student_profile.8fefbdf0.png";